import Skeleton from '@components/skeletons/Skeleton';
import { useDevice } from '@contexts/device';

import {
  SkeletonItemHeader,
  SkeletonItemMain,
  SkeletonItemWrapper,
  MobileSkeletonItemWrapper,
  MobileSkeletonItemContent,
  SkeletonItemPromotions,
  MobileSkeletonItemPrice,
} from './styled';

const TourCardSkeleton = () => {
  const { isDesktop } = useDevice();

  return (
    <>
      {isDesktop ? (
        <SkeletonItemWrapper>
          <Skeleton width={230} height={230} borderRadius={8} />

          <SkeletonItemMain>
            <SkeletonItemHeader>
              <Skeleton width={110} height={23} borderRadius={8} />
              <Skeleton width={232} height={31} borderRadius={8} />
              <Skeleton width={156} height={32} borderRadius={8} />
            </SkeletonItemHeader>
            <SkeletonItemPromotions>
              <Skeleton width={440} height={39} borderRadius={8} />
              <Skeleton width={440} height={39} borderRadius={8} />
            </SkeletonItemPromotions>
          </SkeletonItemMain>
        </SkeletonItemWrapper>
      ) : (
        <MobileSkeletonItemWrapper>
          <Skeleton width={343} height={230} borderRadius={8} />
          <MobileSkeletonItemContent>
            <Skeleton
              width={87}
              height={18}
              borderRadius={8}
              marginBottom={4}
            />
            <Skeleton
              width={87}
              height={18}
              borderRadius={8}
              marginBottom={4}
            />
            <Skeleton
              width={160}
              height={40}
              borderRadius={8}
              marginBottom={4}
            />
            <MobileSkeletonItemPrice>
              <Skeleton
                width={135}
                height={92}
                borderRadius={8}
                marginBottom={4}
              />
            </MobileSkeletonItemPrice>
            <Skeleton
              width={343}
              height={40}
              borderRadius={8}
              marginBottom={4}
            />
          </MobileSkeletonItemContent>
        </MobileSkeletonItemWrapper>
      )}
    </>
  );
};

export default TourCardSkeleton;
